import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { INote } from 'src/app/intefaces/INote';
import { Router } from '@angular/router';
import { CurrencyService } from 'src/app/services/currency.service';
import { Subscription } from 'rxjs';
import { BrowserStorageService } from 'src/app/services/storage.service';
import { getCurrencySymbol } from '@angular/common';
import { DownloadService } from 'src/app/services/download.service';
import { CartService } from 'src/app/services/cart.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-track-item',
  templateUrl: './track-item.component.html',
  styleUrls: ['./track-item.component.scss']
})
export class TrackItemComponent implements OnInit, OnDestroy {
  @Input() trackItem: INote;
  @Input() isSearch: boolean;
  playSrc;
  audioSource: string;
  private currencySubscription : Subscription;
  public selectedCurrency: string;
  public currencySymbol: string;
  playClicked = false;
  previewUrl = environment.previewUrl;
  soundUrl = environment.soundUrl;
  fullScreenImageMode: boolean = false;
  previewWidth: string;

  constructor(
    private router: Router,
    private currencyService: CurrencyService,
    private browserStorageService: BrowserStorageService,
    private cartService: CartService
  ) { }

  ngOnInit(): void {
    this.getCurrency();
    this.currencySubscription = this.currencyService.
    currencyChangeEmitter.subscribe((name: string) => {
      this.getCurrency();
    });
  }

  ngOnDestroy(): void {
    this.currencySubscription.unsubscribe();
  }

  public getCurrency() {
    setTimeout(() => {
      this.selectedCurrency = this.browserStorageService.get("_currency");
      this.currencySymbol = getCurrencySymbol(this.selectedCurrency, "narrow");
    }, 100);
  }


  public playAudio() {
    this.playSrc = `${this.soundUrl}/${this.trackItem.sample_audio}`;
    this.playClicked = true;
  }

  public addToCart() {
    this.cartService.addToCart(this.trackItem);
  }

  public displayCategories(categories): string {
    let categoriesString = '';

    if (categories.length > 0) {
      categories.forEach((cat, index) => {
        if (index + 1 === categories.length) {
          categoriesString += cat?.category?.name;
        } else {
          categoriesString += cat?.category?.name + ', ';
        }
      });
    }

    return categoriesString;
  }

  public handleShowFullScreenImage() {
    const windowRef = this.browserStorageService.windowReference();
    if (windowRef.innerWidth > 576) {
      this.previewWidth = '80vw';
      this.fullScreenImageMode = true;
    } else {
      this.previewWidth = '100vw';
      this.fullScreenImageMode = true;
    }
  }

  public closeFullScreenImage() {
    this.fullScreenImageMode = false;
  }
}
